import { WithdrawalsLimitsRecord } from '@types';

import { WithdrawalsSetLimitsCurrencyReducer } from './types';

export const withdrawalsSetLimitsCurrencyReducer: WithdrawalsSetLimitsCurrencyReducer =
  (state, action) => {
    const { limitId, currency } = action.payload;

    const limitToUpdate = state.withdrawalsLimitsProcessedItems?.[limitId];

    if (!limitToUpdate) {
      return state;
    }

    const updatedItem: WithdrawalsLimitsRecord = {
      [limitId]: {
        ...limitToUpdate,
        currency,
      },
    };

    return {
      ...state,
      withdrawalsLimitsProcessedItems: {
        ...state.withdrawalsLimitsProcessedItems,
        ...updatedItem,
      },
    };
  };
